module.exports = __webpack_public_path__ + "img/euro_green_audi.0577b900.svg";